import { firebase } from '@firebase/app'
const firestore = firebase.firestore()

export default (payload) => {
  return firestore.collection(payload.collection).doc(payload.doc).set(payload.value)
}
